export enum SuppliesEnum {
    DRINK = 'drink',
    FOOD = 'food',
    HOT_FOOD = 'hotFood',
    NONE = 'none',
}
